import { default as domainWorkTimeDate } from './date/store' 

export default { 
	domainWorkTimeDate 
}
